import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ParticipantNavLinks } from './participant-nav-links';
import * as programEnrollmentActions from '../programs/program-permissions.actions';
import { features, featureHelpers } from '../features';
import { integrationTypes, tenantHelpers } from '../tenantInfo';
import './nav.scss';

/** The desktop version of the side nav */
export class Nav extends Component {

  /**
   * Capture information about a keystroke that happened in the side nav bar.
   * @param {object} ev The onKeyDown event.  Use this to get the actual keystroke code.
   * @param {object} navDetail See definition in layout reducer.
   */
  setNavFromKey( ev, navDetail ) {
    const { layoutActions } = this.props;
    layoutActions.setNavFromKey(ev, navDetail);
  }

  render() {
    const { auth, programEnrollment, programEnrollmentActions, layout, tenant } = this.props;
    const { desktopNavCollapsed } = layout || {};

    if ( !featureHelpers.featureEnabled(features.apricotPortalTier2) && tenantHelpers.getIntegrationType() === integrationTypes.apricot) {
      return null;
    }

    if(desktopNavCollapsed) {
      return null;
    }

    return (
      <nav id="sidenav" aria-label="Navigation" className="ssg-forms-scrollable">
        <ParticipantNavLinks
          auth={auth}
          tenant={tenant}
          programEnrollment={programEnrollment}
          programEnrollmentActions={programEnrollmentActions}
          setKey={(e, n) => this.setNavFromKey(e, n)}
          permissions={[]}
        />
      </nav>
    );
  }
}

Nav.propTypes = {
};

const mapStateToProps = ({ auth, routing, programEnrollment, layout, tenant }) => {
  return {
    auth,
    programEnrollment,
    routing,
    layout,
    tenant,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    programEnrollmentActions: bindActionCreators(programEnrollmentActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Nav);



// WEBPACK FOOTER //
// src/layout/nav.js